// src/components/Reveal.jsx
import React from 'react';

const Reveal = ({ 
  children, 
  animation = 'spacejet-fade-up',
  delay = 0,
  className = '' 
}) => {
  return (
    <div
      style={delay > 0 ? { animationDelay: `${delay}ms` } : undefined}
      className={`${className} ${animation}`}
    >
      {children}
    </div>
  );
};

export default Reveal;
